import POLISH_TRANSLATIONS from './PolishTranslations';

export default {
  pl: POLISH_TRANSLATIONS
};
